import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../../hooks/auth.context';

import { Container } from './styles';

const AccountDropdown = () => {
  const { logout } = useAuth();
  const history = useHistory();

  const handleSignOut = () => {
    logout();
    history.push('/');
    toast.warn('Deslogado com sucesso!');
  };

  return (
    <Container onClick={handleSignOut}>
      <span>Sair</span>
    </Container>
  );
};

export default AccountDropdown;
